import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    addPhrasesStartInputItems,
    addPhrasesToChosenList,
    addPhrasesToStartPhrases,
    changeColumnsPhrasesWizardVisibility,
    changePriceContextPhrasesWizard,
    deleteStartPhrases,
    phrasesSelectorSendMinusPhraseData,
    removePhrasesFromChosenList,
    removePhrasesFromMinusWordsList,
    selectionChange,
    SelectionWizardListName
} from '../../actions/phrasesSelectorWizard';
import {
    PhrasesSelectorWizard,
    PhrasesSelectorWizardProps
} from '../../components/PhrasesSelectorWizard/PhrasesSelectorWizard';
import {
    selectPhrasesSelectorHintItems,
    selectPhrasesSelectorKeywordStatPhrases,
    selectPhrasesSelectorMinusWordsListEnabled,
    selectPhrasesSelectorPriceContextEnabled,
    selectPhrasesSelectorWizard
} from '../../selectors/phrasesSelectorWizard/phrasesSelectorWizard';
import {
    PhrasesSelectorColumnsVisibilityData,
    PhrasesSelectorListItem,
    PhrasesSelectorWizardId
} from '../../typings/phrases';
import { State } from '../../typings/state';
import { Omit, TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    cls: string;
    wizardId: PhrasesSelectorWizardId;
    isMinusWordsListEnabled: boolean;
    onSubmit: () => void;
}

type StateProps = TStateProps<PhrasesSelectorWizardProps, Omit<OwnProps, 'isMinusWordsListEnabled'>>;

type DispatchProps = TDispatchProps<PhrasesSelectorWizardProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { wizardId, isMinusWordsListEnabled } = ownProps;
    const {
        startPhrases,
        chosenPhrases,
        isVisible,
        minusWordsList,
        columnsVisibility,
        isInProgress,
        priceContext
    } = selectPhrasesSelectorWizard(state, wizardId);

    const constants = state.commonData.constants;
    const { workCurrency } = state.grid.clientInfo;

    const hintItems = selectPhrasesSelectorHintItems(state, wizardId);

    const isPriceContextEnabled = selectPhrasesSelectorPriceContextEnabled(state, wizardId);
    const calcMinusWordsListEnabled = selectPhrasesSelectorMinusWordsListEnabled(
        state,
        wizardId,
        isMinusWordsListEnabled
    );

    const { similarPhrases, searchedAlsoPhrases } = selectPhrasesSelectorKeywordStatPhrases(state, wizardId);

    return {
        isVisible,
        isInProgress,
        similarPhrases,
        chosenPhrases,
        searchedAlsoPhrases,
        minusWordsList,
        hintItems,
        columnsVisibility,
        startPhrases,
        priceContext,
        workCurrency,
        constants,
        isPriceContextEnabled,
        isMinusWordsListEnabled: calcMinusWordsListEnabled
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    return {
        onStartPhrasesSubmit(value: string[]) {
            dispatch(addPhrasesStartInputItems(ownProps.wizardId, value));
        },
        onSelectionChange(selection: boolean[], listName: SelectionWizardListName) {
            dispatch(selectionChange(ownProps.wizardId, selection, listName));
        },
        deleteStartPhrase(item: PhrasesSelectorListItem) {
            dispatch(deleteStartPhrases(ownProps.wizardId, [item]));
        },
        addPhraseToChosenList(item: PhrasesSelectorListItem[]) {
            dispatch(addPhrasesToChosenList(ownProps.wizardId, item));
        },
        removePhraseFromChosenList(item: PhrasesSelectorListItem) {
            dispatch(removePhrasesFromChosenList(ownProps.wizardId, [item]));
        },
        addPhraseToStartPhrasesList(item: PhrasesSelectorListItem) {
            dispatch(addPhrasesToStartPhrases(ownProps.wizardId, [item]));
        },
        phrasesSelectorSendMinusPhraseData(item: PhrasesSelectorListItem[]) {
            dispatch(phrasesSelectorSendMinusPhraseData(ownProps.wizardId, item));
        },
        removePhraseFromMinusWordsList(item: PhrasesSelectorListItem) {
            dispatch(removePhrasesFromMinusWordsList(ownProps.wizardId, [item]));
        },
        changeColumnsVisibility(value: PhrasesSelectorColumnsVisibilityData) {
            dispatch(changeColumnsPhrasesWizardVisibility(ownProps.wizardId, value));
        },
        changePriceContext(value: number) {
            dispatch(changePriceContextPhrasesWizard(ownProps.wizardId, value));
        }
    };
};

export const PhrasesSelectorWizardContainer = connect<StateProps, DispatchProps, OwnProps, PhrasesSelectorWizardProps>(
    mapStateToProps,
    mapDispatchToProps,
    (stateProps, dispatchProps, ownProps) => ({
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    })
)(PhrasesSelectorWizard);
